/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import UnskipArrow from './unskip-arrow-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <UnskipArrow {...validProps} />;
}
SvgComponent.iconName = 'unskip-arrow-icon';

export const UnskipArrowIcon = svgIconWrapper(SvgComponent);
